/* eslint-disable multiline-ternary */
// ** Core Layout Import
// !Do not remove the Layout import
import Layout from '@layouts/VerticalLayout'

// ** Menu Items Array
import navigation from '@src/navigation/vertical'
import CustomNavbar from './components/Navbar'
import navigationAdmin from '../navigation/vertical/Admin'
import navigationParceria from '../navigation/vertical/Parcerias'
import { useDispatch, useSelector } from 'react-redux'
import navigationSubCliente from '../navigation/vertical/subCliente'
import Realases from '../views/Releases'
import { Info } from 'react-feather'
import './components/realeasesButton.scss'
import { useEffect, useState } from 'react'
import { useEmpresas } from '../Hooks/useEmpresa'
import SystemOff from '../navigation/vertical/SystemOff'
import api from '../services/api'
import { handleGuias, handleSistema } from '../redux/manutencao'
import { useHistory, useLocation } from 'react-router-dom'
import { getDaysDiff, getTipoUser, hasParceria, isUserLoggedIn } from '../utility/Utils'
import moment from 'moment'
import ModalLead from '../Components/ModalLead/ModalLead'
import NavLead from '../Components/navLead/NavLead'
import FilterButton from '../Components/Filter/FilterButton'
const VerticalLayout = props => {
  const { currentEmpresa, estado } = useEmpresas()
  const userState = useSelector((state) => state.auth.userData)
  const [openModal, setOpenModal] = useState(false)
  const [systemOff, setSystemoff] = useState(false)
  const [perfil, setPerfil] = useState(false)
  const systemEstados = localStorage.getItem('sistema')
  const history = useHistory()
  const dispatch = useDispatch()
  const location = useLocation()
  const cliente = {
    cliente: navigation,
    admin: navigationAdmin,
    "sub-cliente": navigationSubCliente,
    "sub-user": navigation,
    "parceria": navigationParceria
  }


  useEffect(() => {
    api.get('/maintenance').then((response) => {
      const { sistema, guia } = response.data.data
      dispatch(handleSistema(sistema))
      dispatch(handleGuias(guia))
    })

    const estados = systemEstados.length > 0 ? systemEstados.toLowerCase().split(',').some(element => element === estado) : false
    if (estados) {
      setSystemoff(true)
      return history.push('/manutencao/estado')
    }
    setSystemoff(false)
    api.get('/maintenance').then((response) => {
      const { sistema, guia } = response.data.data
      dispatch(handleSistema(sistema))
      dispatch(handleGuias(guia))
      if (location.pathname === '/manutencao/estado') {
        history.push('/home')
      }
    })

  }, [currentEmpresa])
  const date = new Date()
  let daysDiff
  if (isUserLoggedIn() !== null) {
    daysDiff = getDaysDiff(moment(date).format('DD/MM/YYYY'), userState.user.venda_expired_at.split('-').reverse().join('/'))
  }

  useEffect(() => {
    if (location.pathname === "/perfil" && (userState.user.venda_asaas_id !== null && userState.user.venda_asaas_id.length !== 0)) {
      setPerfil(false)
    } else {
      setPerfil(true)
    }
    const body = document.getElementsByTagName("body")
    if (location.pathname === '/admin/tickets') {
      body[0].classList.add("overflow-none")
    } else {
      body[0].classList.remove("overflow-none")
    }
  }, [location])


  return (   
    <div className={daysDiff <= 3 && daysDiff >= 0 && userState.user.status === 'teste' ? "nav-lead" : undefined}>
      {daysDiff <= 3 && userState.user.status === 'teste' && <NavLead />}

      <Layout
        menuData={systemOff === false &&
          isUserLoggedIn() !== null ?
          cliente[typeof userState.autenticacao?.tipo === "undefined"
            ? "cliente"
            : userState.user.parceria && getTipoUser() === 'admin' ? "parceria" : userState.autenticacao.tipo.toLowerCase()]
          : SystemOff}
        navbar={<CustomNavbar />}
        {...props}>
        {props.children}
        <div onClick={() => setOpenModal(!openModal)} className='realease-button d-flex align-items-center justify-content-center'>
          <Info />
        </div>
        {daysDiff <= -3 && userState.user.tipo.toLowerCase() !== 'admin' && perfil === true ? <ModalLead /> : null}
        <Realases open={openModal} click={() => setOpenModal(!openModal)} />
      </Layout>
    </div>
  )
}

export default VerticalLayout
